import React from 'react';
import { Button, Popconfirm } from 'antd';

// import { Container } from './styles';

interface IProps {
    record: { id: number };
    name: string;
    handleRemove: (id: number) => void;
}

const RemoveConfirm: React.FC<IProps> = ({ record, name, handleRemove }) => {
    return (
        <>
            <Popconfirm
                title={`Are you sure you want to remove ${name || record.id}?`}
                onConfirm={() => {
                    handleRemove(record?.id);
                }}
                okText="Yes"
                cancelText="No"
            >
                <Button type="link" size="small">
                    Remove
                </Button>
            </Popconfirm>
        </>
    );
};

export default RemoveConfirm;
